


export const setSelectedConsigneeId = ({commit}, params) => {
  commit('SET_SELECTED_CONSIGNEE_ID', params)
}
